import { useState } from "react";
import { Paper, Tab, Tabs } from "@mui/material";
import { PageTitle } from "../../../../shared/ui/common";
import PaymentReports from "../PaymentReports";
import LegacyTransactions from "./LegacyTransactions";

/** Preserves /transaction and its old ledger while exposing the new gateway report. */
export default function ReportTransactions() {
  const [tab, setTab] = useState(0);
  return <>
    <Paper variant="outlined" className="md:mx-3 mx-1 mb-3">
      <Tabs value={tab} onChange={(event, value) => setTab(value)} aria-label="نوع گزارش مالی">
        <Tab id="payment-tab-0" aria-controls="payment-panel-0" label="پرداخت‌های درگاه" />
        <Tab id="payment-tab-1" aria-controls="payment-panel-1" label="سوابق قبلی تراکنش‌ها" />
      </Tabs>
    </Paper>
    <section role="tabpanel" id={`payment-panel-${tab}`} aria-labelledby={`payment-tab-${tab}`}>
      {tab === 0 ? <><PageTitle title="گزارش پرداخت‌ها" broadCrumb={[{ title: "گزارشات", path: "/transaction" }]} /><PaymentReports /></> : <LegacyTransactions />}
    </section>
  </>;
}
